import HeaderBrandArea from './HeaderBrandArea';
export default HeaderBrandArea;


// WEBPACK FOOTER //
// ./src/components/App/Header/HeaderBrandArea/index.js